<script setup>
import { computed } from 'vue'
import { DxDropDownButton } from 'devextreme-vue'

import { getI18n } from '@/plugins/i18n'
import { useCatalog } from '@/composables/catalog'
import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'

const props = defineProps({
  documentType: {
    type: Number,
    default: null,
  },
  displayedSources: {
    type: Array,
    default: null,
  },
  vehicleId: {
    type: Number,
    default: null,
  },
})

const i18n = getI18n()
const registryStore = useRegistryStore()
const webSiteStore = useWebSiteStore()
const { getAvailableCatalogItems, onCatalogLinkClick, onCatalogLrwLinkClick, onAutodataLinkClick } = useCatalog()

const catalogSources = [
  webSiteStore.importRowTypesEnum.CATALOG,
  webSiteStore.importRowTypesEnum.LRW,
  webSiteStore.importRowTypesEnum.AUTODATA,
]

const catalogItems = computed(() => getAvailableCatalogItems(props.documentType, props.displayedSources, { includeAutodata: true })
  .filter(item => catalogSources.includes(item.source)))

const vehicle = computed(() => registryStore.vehicles.find(item => item.id === props.vehicleId))

const onItemClick = (e) => {
  if (e.itemData.source === webSiteStore.importRowTypesEnum.AUTODATA) {
    return onAutodataLinkClick({ targetBlank: false, vehicle: vehicle.value })
  }
  const isPartsPro = e.itemData.source === webSiteStore.importRowTypesEnum.CATALOG
  const open = e.itemData.source === webSiteStore.importRowTypesEnum.LRW ? onCatalogLrwLinkClick : onCatalogLinkClick
  open({
    targetBlank: false,
    vehicle: vehicle.value,
    brandCode: isPartsPro ? registryStore.getSupplierBrandById(vehicle.value?.supplier_brand_ref)?.code : null,
    vin: isPartsPro ? vehicle.value?.vin : null,
  })
}
</script>

<template>
  <dx-drop-down-button
    v-if="catalogItems.length"
    class="q-mr-xs"
    :items="catalogItems"
    :drop-down-options="{ width: 200 }"
    :hint="i18n.t('common.open')"
    :show-arrow-icon="false"
    display-expr="text"
    icon="mdi mdi-monitor-dashboard"
    styling-mode="text"
    @item-click="onItemClick"
  />
</template>
